import { useState } from "react";
import PropTypes from "prop-types";
import CustomCheckBox from "../atoms/custom-checkbox.atom";

const CustomCheckBoxGroup = ({
  label = "",
  error = "",
  helper = "",
  options = [],
  onChange = () => {},
  disabled = false,
  containerStyle,
  inputStyle,
  selectedValues = [],
  id = "",
}) => {
  const [selected, setSelected] = useState(selectedValues);

  const toggleOption = (optionValue) => {
    const updatedSelection = selected.includes(optionValue)
      ? selected.filter((val) => val !== optionValue)
      : [...selected, optionValue];

    setSelected(updatedSelection);
    onChange(updatedSelection);
  };

  return (
    <div style={{ ...styles.container, ...containerStyle }}>
      {label && <label style={styles.label}>{label}</label>}

      <div style={styles.checkboxGroup}>
        {options.map((option) => (
          <label
            key={option.id || option.value}
            style={{
              ...styles.checkboxLabel,
              ...(disabled && styles.disabled),
              ...inputStyle,
            }}
          >
            <CustomCheckBox
              label={option.label}
              checked={selected.includes(option.value)}
              onChange={() => toggleOption(option.value)}
              disabled={disabled}
              checkboxStyle={{ borderColor: "#facd07" }}
              id={`${id}-option-${option.id}`}
            />
          </label>
        ))}
      </div>

      {helper && <p style={styles.helper}>{helper}</p>}
      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter, sans-serif",
  },
  label: {
    marginBottom: 8,
    fontWeight: "bold",
    fontSize: 16,
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
  },
  helper: {
    marginTop: 4,
    fontSize: 12,
    color: "#666",
  },
  error: {
    marginTop: 4,
    fontSize: 12,
    color: "red",
  },
  disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
};

CustomCheckBoxGroup.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  helper: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  containerStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  selectedValues: PropTypes.array,
};

export default CustomCheckBoxGroup;
